"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const roles_entity_1 = require("./roles.entity");
const user_1 = require("./user");
let UserRole = class UserRole {
    constructor(id, userId, roleId, user, role) {
        this.id = id;
        this.userId = userId;
        this.roleId = roleId;
        this.user = user;
        this.role = role;
    }
};
exports.UserRole = UserRole;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], UserRole.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "user_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], UserRole.prototype, "userId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "role_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], UserRole.prototype, "roleId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_1.User, { nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: "user_id" }),
    tslib_1.__metadata("design:type", Object)
], UserRole.prototype, "user", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => roles_entity_1.Role, { nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: "role_id" }),
    tslib_1.__metadata("design:type", Object)
], UserRole.prototype, "role", void 0);
exports.UserRole = UserRole = tslib_1.__decorate([
    (0, typeorm_1.Entity)("user_role"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Object, Object])
], UserRole);
